import styled, { css } from 'styled-components';
import { getColor, getSpace, px2rem, mq, getTransition } from '../../../../stylesheets/tools';

const dotsTransition = '/static/dots/footer-background.svg';

const backgroundColors = {
  ressources: {
    default: '#9770C8',
    dark: '#64389A'
  },
  agriculture: {
    default: '#A6DD89',
    dark: '#6AA349'
  },
  work: {
    default: '#E26372',
    dark: '#B04B57'
  },
  energy: {
    default: '#AD7496',
    dark: '#92577A'
  },
  nutrition: {
    default: '#45A88F',
    dark: '#308D76'
  },
  health: {
    default: '#EE9E77',
    dark: '#EA7137'
  },
  mobility: {
    default: '#F3C85E',
    dark: '#D39908'
  },
  city: {
    default: '#117D94',
    dark: '#0D6477'
  },
  democracy: {
    default: '#D1578D',
    dark: '#8E3B60'
  }
};

const StyledEducationStartStage = styled.section`
  .start-stage__container {
    position: relative;
    padding: ${px2rem('200px')} 0 260px 0;
    overflow: hidden;

    ${mq('m')} {
      padding: ${px2rem('200px')} 0 360px 0;
    }

    &:before {
      z-index: 1;
      content: '';
      right: 0;
      position: absolute;
      width: 100%;
      bottom: -80px;
      height: 218px;
      background-color: white;
      mask-image: url(${dotsTransition});
      mask-size: 296px 218px;
      mask-repeat: repeat;
    }

    .start-stage__content {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      h1 {
        margin-bottom: ${getSpace('s')};

        span {
          &.small {
            display: block;
            margin-bottom: ${px2rem('10px')};
            font-size: ${px2rem('20px')};
          }
          &.big {
            line-height: 1.25;
            font-size: ${px2rem('44px')};
          }
        }
      }
      &.content--light {
        h1,
        .start-stage__copy {
          color: white;
        }
      }
      &.content--dark {
        h1,
        .start-stage__copy {
          color: black;
        }
      }

      ${mq('m')} {
        h1 {
          span {
            &.small {
              font-size: ${px2rem('40px')};
            }
            &.big {
              font-size: ${px2rem('80px')};
            }
          }
        }
      }
      .start-stage__copy {
        max-width: ${px2rem('600px')};

        p {
          line-height: 1.75;
        }
      }
    }
  }
  .start-stage__dots {
    position: absolute;
    bottom: -2px;
    width: 100%;
    height: 170px;
    background-size: contain;
    background-repeat: repeat;
    -webkit-transform: scaleY(-1) rotate(180deg);
    -ms-transform: scaleY(-1) rotate(180deg);
    transform: scaleY(-1) rotate(180deg);
    background-image: url(${dotsTransition});
  }
  .start-stage__video {
    position: absolute;
    mix-blend-mode: multiply;
    opacity: 0.8;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  .start-stage__bg {
    position: absolute;
    width: 100%;
    height: 100%;
    inset: 0;
    ${getTransition()}

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100;
      inset: 0;
      z-index: -1;
      background: linear-gradient(
        90deg,
        rgba(88, 77, 248, 1) 0%,
        rgba(50, 144, 245, 1) 51%,
        rgba(76, 162, 222, 1) 100%
      );
    }
  }
  .start-stage__bg-front {
    position: absolute;
    width: 100%;
  }
  ${({ category }) =>
    category !== ''
      ? css`
          .start-stage__bg {
            background: ${backgroundColors[category]?.default || 'inherit'};
          }
        `
      : css`
          .start-stage__bg-front {
            opacity: 0.8;
            height: 50%;
            bottom: 0;
            filter: blur(80px);
            background: rgb(131, 58, 180);
            background: linear-gradient(
              90deg,
              rgba(131, 58, 180, 0) 0%,
              rgba(235, 53, 209, 1) 20%,
              rgba(248, 173, 127, 1) 80%,
              rgba(248, 173, 127, 0) 100%
            );
          }
        `}
  .start-stage__teaser {
    margin-top: -260px;

    ${mq('m')} {
      margin-top: -360px;
    }
    .start-stage__teaser-select-topic {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      color: ${getColor('darkGray')};
      gap: ${px2rem('10px')};
      position: relative;
      z-index: 2;

      span {
        font-size: ${px2rem('20px')};
      }

      ${mq('l')} {
        margin-top: -40px;
      }
      ${mq('m')} {
        gap: ${px2rem('15px')};

        svg {
          height: 24px;
          width: 24px;
        }
        span {
          font-size: ${px2rem('26px')};
        }
      }
    }
  }
  .start-stage__list-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${getSpace('l')} 0;

    .hidden {
      &--mobile {
        display: none;

        ${mq('m')} {
          display: block;
        }
      }
      &--desktop {
        ${mq('m')} {
          display: none;
        }
      }
    }
    ${({ category }) =>
      category !== '' &&
      css`
        .arrow-link .arrow-link__icon {
          background: ${backgroundColors[category]?.dark || 'inherit'};
        }
      `}
  }
  .start-stage__list {
    padding: ${getSpace('l')} 0 ${getSpace('xxl')} 0;
  }
`;

export default StyledEducationStartStage;
